import React from 'react';
import Aboutus from './Aboutus';
import Services from './Services';
import Portfolio from './Portfolio';
import Team from './Team';
import Testimonials from './Testimonials';

const About = () => {
    return (
        <>
            <Aboutus />
            <Services />
            <Portfolio />
            <Team />
            <Testimonials />
        </>
    )
}

export default About
